import { Component, OnInit } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { NativeStorage } from '@awesome-cordova-plugins/native-storage/ngx';
import {
  AlertController,
  LoadingController,
  ModalController,
  NavController,
  NavParams,
  Platform,
  ToastController,
} from '@ionic/angular';
import { GlobalVariable } from '../global';
import { ServerService } from '../providers/server.service';
import { GooglePlus } from '@awesome-cordova-plugins/google-plus/ngx';
// import {
//   Facebook,
//   FacebookLoginResponse,
// } from '@awesome-cordova-plugins/facebook/ngx';
import { ForgotPasswordPage } from '../forgot-password/forgot-password.page';
declare var cordova: any;
interface LoginData {
  email: String;
  password: String;
}
@Component({
  selector: 'app-login',
  templateUrl: './login.page.html',
  styleUrls: ['./login.page.scss'],
})
export class LoginPage implements OnInit {
  loginData: LoginData;
  loginForm: FormGroup;
  submitAttempt: boolean = false;
  // loginForm: FormGroup;
  phoneLoginForm: FormGroup;
  data: any;
  places = [];
  login_type = 'email';
  pos_customer: boolean = false;
  phone: any;
  code = '+1';
  profile_complete: any;
  userData: any;
  appleLogin: boolean = false;
  PassType: string = 'password';

  constructor(
    public server: ServerService,
    public globals: GlobalVariable,
    private nativeStorage: NativeStorage,
    public modalCtrl: ModalController,
    public navCtrl: NavController,
    public navParams: NavParams,
    public googlePlus: GooglePlus,
    public loadingCtrl: LoadingController,
    // public facebook: Facebook,
    // public fb: FacebookOriginal,
    public alertCtrl: AlertController,
    public fb: FormBuilder,
    public platform: Platform,
    public toastCtrl: ToastController
  ) {
    if (this.platform.is('ios')) {
      this.appleLogin = true;
    }
    this.loginData = {} as LoginData;
  }

  ngOnInit() {
    this.loginForm = this.fb.group({
      email: new FormControl(
        '',
        Validators.compose([
          Validators.required,
          Validators.pattern('^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+.[a-zA-Z0-9-.]+$'),
        ])
      ),
      password: new FormControl(
        '',
        Validators.compose([Validators.required, Validators.minLength(6)])
      ),
    });
    this.data = {};

    this.data.response = '';
    console.log(this.loginData);
  }
  ionViewDidEnter() {
    this.togglePassword();
  }
  createAccount() {
    this.navCtrl.navigateForward('/signup', {
      state: { profile_complete: true },
    });
    // this.navCtrl.push(IntroPage3Page, { profile_complete: true });
  }

  register() {
    // this.navCtrl.push(IntroPage3Page, {
    //   phone: phone,
    //   profile_complete: false,
    // });
    this.navCtrl.navigateForward('signup', {
      state: {
        profile_complete: false,
      },
    });
  }

  login(LoginData: any) {

    let cleanEmail=this.loginForm.value.email.trim();
    // let cleanEmail=this.loginForm.value.email.replace(/\s/g, '');
    this.loginForm.get('email').setValue(cleanEmail);
    if (this.login_type == 'email') {
      if (!this.loginForm.valid) {
        this.submitAttempt = true;
      } else {
        this.loginAPI(LoginData);
      }
    }

    if (this.login_type == 'phone') {
      if (!this.phoneLoginForm.valid) {
        this.submitAttempt = true;
      } else {
        this.loginAPI(LoginData);
      }
    }
  }

  async loginAPI(LoginData: any) {
    this.globals.Loader();
    // let loading = await this.loadingCtrl.create({
    //   message: "Please wait...",
    //   // cssClass:'custom_loading',
    //   // spinner:'hide'
    // });
    // this.globals.loading.present();

    let response = this.server.LoginData(LoginData);
    response.subscribe(
      (data) => {
        console.log(data);
        this.globals.loading.dismiss();
        this.data.response = data;

        if (this.data.response != 'invalid') {
          this.globals.guess_login = false;
          localStorage.setItem('userphone', this.data.response.phone);
          this.globals.udid = this.data.response.udid;
          console.log('Login api data', this.data.response);
          this.globals.currentUser = this.data.response;
          localStorage.setItem('userEmail', LoginData.email.trim());
          localStorage.setItem('firstname', this.data.response.firstname);
          localStorage.setItem('isLogin', JSON.stringify(true));
          localStorage.setItem('udid', this.data.response.udid);
          // this.globals.udid=localStorage.getItem('udid');
          this.globals.firstName = this.data.response.firstname;
          this.globals.lastName = this.data.response.lastname;
          this.globals.Email = LoginData.email;
          this.profile_complete = this.data.response.profile_complete;
          this.getNotificationData();
          this.loadBanner();
          if (this.globals.caos_flag) {
            // this.navCtrl.pop();
          } else {
            if (!this.profile_complete) {
              // this.register(LoginData.phone);
            } else {
              // if (!this.globals.marketPlace) {
              //   this.list();
              // }
              this.nativeStorage
                .setItem('user', {
                  email: LoginData.email,
                  udid: this.data.response.udid,
                  firstName: this.data.response.firstname,
                  lastName: this.data.response.lastname,
                  phone: this.data.response.phone,
                  password: LoginData.password,
                  image: this.data.response.url,
                  ID: this.data.response.id,
                  date: this.data.response.date_joined,
                  phone_verify: this.data.response.phone_verified,
                  birthday: this.data.response.birthday,
                  aniversary: this.data.response.anniversary,
                })
                .then(() => {
                  this.SaveMobileNumberFlag(
                    this.data.response.mobile_verification_amount,
                    this.data.response.phone_verified
                  );
                  if (this.globals.caos_flag) {
                    this.navCtrl.navigateForward('cart');
                  } else {
                    // if (this.globals.marketPlace) {
                    this.navCtrl.navigateRoot('home');
                    // this.close()
                  }
                  //  else {
                  // this.navCtrl.navigateRoot('home', {
                  //   imageData: this.data.response.url,
                  //   Flag: false,
                  // });
                  // }
                  // }
                })
                .catch((err) => {
                  this.SaveMobileNumberFlag(
                    this.data.response.mobile_verification_amount,
                    this.data.response.phone_verified
                  );

                  if (this.globals.caos_flag) {
                    this.navCtrl.navigateForward('/cart');
                  } else {
                    // if (this.globals.marketPlace) {
                    // this.close()

                    this.navCtrl.navigateRoot('home');
                  }
                  //  else {
                  // this.navCtrl.setRoot(HomePage, {
                  //   imageData: this.data.response.url,
                  //   Flag: false,
                  // });
                  // }
                  // }
                });
            }
          }
        } else {
          this.globals.presentToast('Invalid Credentials');
        }
      },
      (error) => {
        this.globals.loading.dismiss();
        this.globals.presentToast(
          'Something went wrong check your internet connection.'
        );
      }
    );
  }

  async forgotPass() {
    let modal = await this.modalCtrl.create({
      component: ForgotPasswordPage,
    });
    modal.present();
  }

  OpenTermsAndPolicy() {
    this.navCtrl.navigateForward('terms-policy');
  }

  SaveMobileNumberFlag(amount, flag) {
    this.globals.MobileDiscount = Number(amount);

    this.nativeStorage
      .setItem('MobileFlagSave', {
        MobileFlag: flag,
        MobileDiscount: Number(amount),
      })
      .then(
        () => {},
        (error) => console.error('Error storing item', error)
      );
  }
  close() {
    this.navCtrl.pop();
    // this.modalCtrl.dismiss();
  }
  list() {
    let response = this.server.getRestaurantslist(
      '100000',
      'main',
      '0,0',
      '0',
      'order',
      100
    );
    response.subscribe(
      (data) => {
        this.places = data.results;
        var new_id = this.globals.new_id;
        this.globals.business_list = this.places;
        this.places = this.places.filter(function (item) {
          return item.business_id === new_id;
        });
        this.globals.business_name = this.places[0].name;
        this.globals.business_phone = this.places[0].phone;
        this.globals.business_address = this.places[0].address;
        this.globals.point_check = this.places[0].points_enabled;
        this.globals.punch_check = this.places[0].punches_enabled;
        this.globals.special_offer = this.places[0].special_offer;
        this.globals.events_enabled = this.places[0].events_enabled;
        this.globals.gallery_enabled = this.places[0].gallery_enabled;
        this.globals.pickup = this.places[0].pickup;
        this.globals.latitude = this.places[0].latitude;
        this.globals.longitude = this.places[0].longitude;
        this.globals.hours_operation = this.places[0].hours_operation;
        this.globals.branch_enabled = this.places[0].branch_enabled;
        this.globals.giftcard_enabled = this.places[0].giftcard_enabled;
        this.globals.b_logo = this.places[0].logo;
        this.globals.home_logo = this.places[0].logo;
        this.globals.StripId = this.places[0].stripe_id;
        this.globals.order_instructions = this.places[0].instructions_enabled;
        this.globals.pickup_timing = this.places[0].pickup_timing;
        this.globals.delivery_timing = this.places[0].delivery_timing;
        this.globals.business_username = this.places[0].username;
        this.globals.estimated_time = this.places[0].delivery_time;
        this.globals.business_discount_count = parseInt(
          this.places[0].business_discount_count
        );
        this.globals.username = this.places[0].username;
        this.globals.bussinessId = this.places[0].business_id;
        this.globals.admin_stripe = this.places[0].admin_stripe_enabled;
        this.globals.pickupsetting = this.places[0].delivery_time;
        this.globals.tax = this.places[0].tax;
        this.globals.deliveryCharges = this.places[0].delivery_fee;
        this.globals.pickup_Time = this.places[0].pickup_time;
        this.globals.minimun_order = parseInt(this.places[0].minimum_order);
        this.globals.availed_discount_count = parseInt(
          this.places[0].customer_discount_availed_count
        );
        this.globals.paypalId = this.places[0].paypal_id;
        this.globals.Timing = this.places[0].hours_operation;
        this.globals.specific_delivery_day =
          this.places[0].specific_delivery_day;
        this.globals.review_enabled = this.places[0].review_enabled;
        this.globals.delivery_day = this.places[0].delivery_day;
        this.globals.authorize_enabled = this.places[0].authorize_enabled;
        this.globals.card_enabled = this.places[0].card_enabled;
        this.globals.admin_stripe_enabled = this.places[0].admin_stripe_enabled;
        this.globals.catering_enabled = this.places[0].catering_enabled;
        this.globals.catering_cart_enabled =
          this.places[0].catering_cart_enabled;
        this.globals.giftcard_amount_limit = this.places[0].giftcard_limit;
        this.globals.business_type = this.places[0].business_type;
        this.globals.orders_enabled = this.places[0].orders_enabled;
        this.globals.BusinessDiscount = this.places[0].discount;
        this.globals.ccFeeDisclaimer = this.places[0].ccFeeDisclaimer;

        this.globals.tip_enabled = this.places[0].tip_enabled;
        this.globals.menu_ready = this.places[0].menu_ready;
        this.globals.utensils_enabled = this.places[0].utensils_enabled;

        if (this.globals.pickup == '1') {
          this.globals.pickup = true;
        } else {
          this.globals.pickup = false;
        }

        if (this.places[0].delivery == '1') {
          this.globals.delivery = true;
        } else {
          this.globals.delivery = false;
        }

        if (this.places[0].cash_enabled == '1') {
          this.globals.cash_enabled = true;
        } else {
          this.globals.cash_enabled = false;
        }

        if (this.globals.pickup == '1') {
          this.globals.pickup = true;
        } else {
          this.globals.pickup = false;
        }

        if (this.places[0].delivery == '1') {
          this.globals.delivery = true;
        } else {
          this.globals.delivery = false;
        }
      },
      (error) => {
        this.globals.presentToast(
          'Something went wrong check your internet connection.'
        );
      }
    );
  }

  check_phone_number() {
    this.pos_customer = true;
  }

  cancel_pos() {
    this.pos_customer = false;
  }

  // async complete_profile() {
  //   let loading = await this.loadingCtrl.create({
  //     message: "Please wait...",
  //   });
  //   loading.present();

  //   let response = this.server.check_user_by_phone(this.code + this.phone);
  //   response.subscribe(
  //     (data) => {
  //       loading.dismiss();
  //       this.globals.presentToast(data.message);

  //       if (!data.success) {
  //         this.pos_customer = false;
  //       } else {
  //         if (data.data.profile_complete) {
  //           this.pos_customer = false;
  //         } else {
  //           //this.register();
  //         }
  //       }
  //     },
  //     (error) => {
  //       this.globals.presentToast(
  //         "Something went wrong check your internet connection."
  //       );
  //     }
  //   );
  // }

  async doAppleLogin() {
    let toast = await this.toastCtrl.create({
      message: 'Logging in.....',
      color:'dark'
    });
    toast.present();
    cordova.plugins.SignInWithApple.signin(
      { requestedScopes: [0, 1] },
      (succ) => {
        // console.log("login with apple res ", succ);
        console.log('login with apple res ', JSON.stringify(succ));
        // alert(JSON.stringify(succ));
        // alert(succ.identityToken);
        // alert(succ.authorizationCode);
        // alert('apple usertoken=>   '+succ.user);
        // alert('token2=> '+succ.sub)

        succ.fullName.familyName;
        succ.fullName.givenName;
        succ.email;
        let responseToApi = this.server.SignupData(
          true,
          succ.fullName.givenName,
          succ.fullName.familyName,
          succ.email,
          '',
          '',
          '',
          '',
          '',
          succ.user
        );
        responseToApi.subscribe(
          (response) => {
            toast.dismiss();
            if(response.status!='error'){
            localStorage.setItem('userphone', response.customer_data.phone);

            console.log('apple login api res ', response);
            // alert(JSON.stringify(response));
            this.globals.udid = response.udid;
            localStorage.setItem('udid', response.udid);
            localStorage.setItem('userEmail', response.customer_data.email.trim());
            this.globals.Email = response.customer_data.email;
            localStorage.setItem('isLogin', JSON.stringify(true));
            localStorage.setItem('isSocialLogin', JSON.stringify(true));
            localStorage.setItem(
              'firstname',
              // succ.fullName.givenName,
              response.customer_data.first_name
            );
            this.nativeStorage.setItem('user', {
              email: response.customer_data.email,
              udid: this.globals.udid,
              firstName: response.customer_data.first_name,
              lastName: response.customer_data.last_name,
              ID: response.customer_data.id,
              url: response.customer_data.url,
              phone: response.customer_data.phone,
            });
          this.loadBanner();

            this.getNotificationData();
            // this.close()

            this.navCtrl.navigateRoot('home');
          }
          else{
            this.globals.presentToast(response.description)
          }
          },
          (failed) => {
            this.globals.presentToast('Failed to login. Network error');

            toast.dismiss();

            console.log('apple login api failed', failed);
          }
        );
      },
      (err) => {
        toast.dismiss();
        this.globals.presentToast('Failed to login try again later.');
        // console.error(err);
        console.log(JSON.stringify(err));
        //    alert(JSON.stringify(err));
      }
    )
  }

  async googleLogin() {
    let toast = await this.toastCtrl.create({
      message: 'Logging in.....',
    });
    toast.present();
    // let options = {
    //     scopes: "", // optional, space-separated list of scopes, If not included or empty, defaults to `profile` and `email`.
    //     webClientId:
    //         "1044840233950-59lnk01tri7dnel53iaum8mfn5epcg8n.apps.googleusercontent.com", // optional clientId of your Web application from Credentials settings of your project - On Android, this MUST be included to get an idToken. On iOS, it is not required.
    //     offline: true, // optional, but requires the webClientId - if set to true the plugin will also return a serverAuthCode, which can be used to grant offline access to a non-Google server
    // };

    let options;
    if (this.platform.is('ios')) {
      options = {};
    } else {
      // 1044840233950-59lnk01tri7dnel53iaum8mfn5epcg8n.apps.googleusercontent.com // optional clientId of your Web application from Credentials settings of your project - On Android, this MUST be included to get an idToken. On iOS, it is not required.
      options = {
        scopes: '', // optional, space-separated list of scopes, If not included or empty, defaults to `profile` and `email`.
        webClientId:
          '1017331347712-jfghs8ikpcrh3hi5qjv3fj4rjihgnvnm.apps.googleusercontent.com',
        offline: true, // optional, but requires the webClientId - if set to true the plugin will also return a serverAuthCode, which can be used to grant offline access to a non-Google server
      };
    }

    this.googlePlus
      .login({ options })
      .then(
        (res) => {
          // toast.dismiss();

          console.log('google login data=> ', res);
          // if(res.userId){
          this.globals.guess_login = false;
          this.globals.udid = res.userId;
          //  localStorage.setItem("udid",res.userId);
          localStorage.setItem('userEmail', res.email.trim());
          localStorage.setItem('isLogin', JSON.stringify(true));
          localStorage.setItem('isSocialLogin', JSON.stringify(true));
          localStorage.setItem('firstname', res.givenName);
          //saving data to database
          let responses = this.server.SignupData(
            true,
            res.givenName,
            res.familyName,
            res.email,
            '',
            '',
            '',
            '',
            ''
          );
          responses.subscribe(
            (response) => {
              toast.dismiss();
            if(response.status!='error'){

              localStorage.setItem('userphone', response.customer_data.phone);

              console.log('data recieved from api for google login', res);
              this.globals.udid = response.udid;
              localStorage.setItem('udid', response.udid);

              this.nativeStorage.setItem('user', {
                email: response.customer_data.email,
                udid: this.globals.udid,
                firstName: response.customer_data.first_name,
                lastName: response.customer_data.last_name,
                phone: response.customer_data.phone,
                // password: LoginData.password,
                url: this.data.response.url,
                ID: response.customer_data.id,
                // date: this.data.response.date_joined,
                // phone_verify: this.data.response.phone_verified,
                // birthday: this.data.response.birthday,
                // aniversary: this.data.response.anniversary
              });
              // }
          this.loadBanner();

              this.getNotificationData();
              // this.close()

              this.navCtrl.navigateRoot('home');
            }
            else{
              this.globals.presentToast(response.description)
            }
            },
            (err) => {
              console.log(err);
              toast.dismiss();
              this.globals.presentToast('Something went wrong. Try again');
            }
          );
            
          //saving in storage
        },
        (err) => {
          console.log(err,'failed')
          toast.dismiss();
        }
      )
      .catch((err) => {
        console.log(err,'failed')

        toast.dismiss();

        console.error('G+ login Error-> ', err);
        this.globals.presentToast('Failed to login try again');
      });
  }
  // async fbLogin() {
  //   let toast = await this.toastCtrl.create({
  //     message: 'Logging in.....',
  //   });
  //   toast.present();

  //   this.facebook
  //     .login(['email', 'public_profile'])
  //     .then(
  //       async (response: FacebookLoginResponse) => {
  //         console.log('login with fb ', response);
  //         if ((response.status = 'connected')) {
  //           this.globals.guess_login = false;
  //           // this.globals.udid = response.authResponse.userID;
  //           // localStorage.setItem("udid", response.authResponse.userID);

  //           // this.facebook.api("/me",[])
  //           this.facebook
  //             .api('me?fields=id,email,first_name,last_name', [])
  //             .then(async (profile) => {
  //               console.log('fb profile data res', profile);
  //               this.userData = {
  //                 email: profile['email'],
  //                 phone: profile['phone'],
  //                 first_name: profile['first_name'],
  //                 last_name: profile['last_name'],
  //                 // picture: profile["picture_large"]["data"]["url"],
  //                 // username: profile["name"],
  //               };
  //               console.log('email from fb ', this.userData.email);
  //               // this.userData.email=null;
  //               if (
  //                 this.userData.email == null ||
  //                 this.userData.email == undefined ||
  //                 this.userData.email == ''
  //               ) {
  //                 let alert = await this.alertCtrl.create({
  //                   header: 'Email is required',
  //                   subHeader:
  //                     'Please Enter your email first, as it is required for placing orders and reviews.',
  //                   inputs: [
  //                     {
  //                       name: 'email',
  //                       placeholder: 'Your Email',
  //                       attributes: {
  //                         minlength: 10,
  //                       },
  //                     },
  //                   ],
  //                   buttons: [
  //                     {
  //                       text: 'Cancel',
  //                       role: 'cancel',
  //                       handler: (data) => {
  //                         console.log('handler', data);
  //                         this.globals.presentToast(
  //                           'login Failed as email is required to continue.',
  //                           4000,
  //                           'middle'
  //                         );
  //                         localStorage.removeItem('isLogin');
  //                         localStorage.removeItem('udid');
  //                         toast.dismiss();
  //                       },
  //                     },
  //                     {
  //                       text: 'Submit',
  //                       handler: (data) => {
  //                         toast.dismiss();
  //                         console.log('submit', data.email);
  //                         var validRegex =
  //                           /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;

  //                         if (data.email.match(validRegex)) {
  //                           // if email not provided by facebook.. assk manually for email
  //                           let responseToApi = this.server.SignupData(
  //                             true,
  //                             this.userData.first_name,
  //                             this.userData.last_name,
  //                             data.email,
  //                             '',
  //                             '',
  //                             '',
  //                             '',
  //                             ''
  //                           );
  //                           responseToApi.subscribe(
  //                             (res) => {
  //                               toast.dismiss();
  //                               localStorage.setItem(
  //                                 'userphone',
  //                                 res.customer_data.phone
  //                               );

  //                               console.log(
  //                                 'data recieved from api for fb login',
  //                                 res
  //                               );
  //                               this.globals.udid = res.udid;
  //                               localStorage.setItem('udid', res.udid);
  //                               localStorage.setItem(
  //                                 'userEmail',
  //                                 res.customer_data.email
  //                               );

  //                               this.nativeStorage.setItem('user', {
  //                                 email: res.customer_data.email,
  //                                 udid: this.globals.udid,
  //                                 firstName: res.customer_data.first_name,
  //                                 lastName: res.customer_data.last_name,
  //                                 phone: res.customer_data.phone,
  //                                 // password: LoginData.password,
  //                                 url: this.data.response.url,
  //                                 ID: res.customer_data.id,
  //                                 // date: this.data.response.date_joined,
  //                                 // phone_verify: this.data.response.phone_verified,
  //                                 // birthday: this.data.response.birthday,
  //                                 // aniversary: this.data.response.anniversary
  //                               });

  //                               localStorage.setItem(
  //                                 'isLogin',
  //                                 JSON.stringify(true)
  //                               );
  //                               localStorage.setItem(
  //                                 'isSocialLogin',
  //                                 JSON.stringify(true)
  //                               );
       

  //                               this.getNotificationData();
  //                               console.log(
  //                                 'Userdata from facebook',
  //                                 this.userData
  //                               );
  //                               localStorage.setItem(
  //                                 'firstname',
  //                                 this.userData.first_name
  //                               );
  //                               // this.close()

  //                               this.navCtrl.navigateRoot('home');
  //                             },
  //                             (err) => {
  //                               console.log(err);
  //                               toast.dismiss();

  //                               this.globals.presentToast(
  //                                 'Failed to login try again'
  //                               );
  //                             }
  //                           );
  //                         } //if con
  //                         else {
  //                           this.globals.presentToast(
  //                             'Invalid Email',
  //                             2000,
  //                             'middle'
  //                           );
  //                         }
  //                       },
  //                     },
  //                   ],
  //                 });

  //                 alert.present();
  //               } else {
  //                 let responseToApi = this.server.SignupData(
  //                   true,
  //                   this.userData.first_name,
  //                   this.userData.last_name,
  //                   this.userData.email,
  //                   '',
  //                   '',
  //                   '',
  //                   '',
  //                   ''
  //                 );
  //                 responseToApi.subscribe(
  //                   (res) => {
  //                     toast.dismiss();
  //                     localStorage.setItem(
  //                       'userphone',
  //                       res.customer_data.phone
  //                     );
  //                     console.log('data recieved from api for fb login', res);
  //                     this.globals.udid = res.udid;
  //                     localStorage.setItem('udid', res.udid);
  //                     localStorage.setItem(
  //                       'userEmail',
  //                       res.customer_data.email
  //                     );

  //                     this.nativeStorage.setItem('user', {
  //                       email: res.customer_data.email,
  //                       udid: this.globals.udid,
  //                       firstName: res.customer_data.first_name,
  //                       lastName: res.customer_data.last_name,
  //                       phone: res.customer_data.phone,
  //                       // password: LoginData.password,
  //                       url: this.data.response.url,
  //                       ID: res.customer_data.id,
  //                       // date: this.data.response.date_joined,
  //                       // phone_verify: this.data.response.phone_verified,
  //                       // birthday: this.data.response.birthday,
  //                       // aniversary: this.data.response.anniversary
  //                     });

  //                     localStorage.setItem('isLogin', JSON.stringify(true));
  //                     localStorage.setItem(
  //                       'isSocialLogin',
  //                       JSON.stringify(true)
  //                     );
  //         this.loadBanner();

  //                     this.getNotificationData();
  //                     console.log('Userdata from facebook', this.userData);
  //                     localStorage.setItem(
  //                       'firstname',
  //                       this.userData.first_name
  //                     );
  //                     // this.close()

  //                     this.navCtrl.navigateRoot('home');
  //                   },
  //                   (err) => {
  //                     console.log(err);
  //                     toast.dismiss();

  //                     this.globals.presentToast('Failed to login try again');
  //                   }
  //                 );
  //               }

  //               // ,err=>{console.log(err)}
  //               // )

  //               //saving data to database

  //               // this.nativeStorage.setItem("user", {
  //               //     email: this.userData.email,
  //               //     udid: this.globals.udid,
  //               //     firstName: this.userData.first_name,
  //               //     lastName: this.userData.last_name,
  //               //     phone: "",
  //               //     // password: LoginData.password,
  //               //     // image: this.data.response.url,
  //               //     ID: response.authResponse.userID,
  //               //     // date: this.data.response.date_joined,
  //               //     // phone_verify: this.data.response.phone_verified,
  //               //     // birthday: this.data.response.birthday,
  //               //     // aniversary: this.data.response.anniversary
  //               // });

  //               // localStorage.setItem("isLogin", JSON.stringify(true));
  //               // localStorage.setItem("isSocialLogin", JSON.stringify(true));
  //               // this.getNotificationData();
  //               // this.navCtrl.setRoot("LandingPage");
  //             });
  //         } else {
  //           toast.dismiss();

  //           const alert = await this.alertCtrl.create({
  //             message: 'Facebook login failed. try again',
  //             buttons: ['OK'],
  //           });
  //           await alert.present();
  //           console.log('failed login with facebook no response');
  //         }
  //       },
  //       (err) => {
  //         toast.dismiss();
  //         this.globals.presentToast('Failed to login');
  //       }
  //     )
  //     .catch((e) => {
  //       this.globals.presentToast('Failed to login');

  //       console.log('Error logging into Facebook', e);
  //       toast.dismiss();
  //     });
  //   //   this.facebook.login(['public_profile', 'email'])
  //   //         .then((res: FacebookLoginResponse) => console.log('Logged into Facebook!', res))
  //   //         .catch(e => console.log('Error logging into Facebook', e));

  //   // this.facebook.logEvent(this.facebook.EVENTS.EVENT_NAME_ADDED_TO_CART);
  // }

  getNotificationData() {
    if (this.globals.userId) {
      let response = this.server.getNotificationData(
        this.globals.oneSignalAppId,
        this.globals.userId,
        this.globals.udid
      );
      console.log(
        'sending this data to api > ',
        this.globals.oneSignalAppId,
        this.globals.userId,
        this.globals.udid
      );
      response.subscribe((data) => {
        console.log('notification api response', data);
      });
    } else {
      console.log('not sending one signal data');
    }
  }
  // doGoogleLogin() {
  //     let options = {
  //         'scopes': '', // optional, space-separated list of scopes, If not included or empty, defaults to `profile` and `email`.
  //         'webClientId': '859537130755-aoipu1fgmh0mu2ro99ihkjntfbt2ege4.apps.googleusercontent.com', // optional clientId of your Web application from Credentials settings of your project - On Android, this MUST be included to get an idToken. On iOS, it is not required.
  //         'offline': true // optional, but requires the webClientId - if set to true the plugin will also return a serverAuthCode, which can be used to grant offline access to a non-Google server
  //     };
  //     this.googlePlus.login(options).then(res => {
  //         console.log("G+ login Success-> ", res)

  //     })
  //     .catch(err => {
  //         console.error("G+ login Error-> ",  err)
  //     });
  // }

  // doFacebookLogin() {
  //     this.fb.login(['public_profile', 'user_friends', 'email'])
  //         .then((res: FacebookLoginResponse) => console.log('Logged into Facebook!', res))
  //         .catch(e => console.log('Error logging into Facebook', e));

  //     this.fb.logEvent(this.fb.EVENTS.EVENT_NAME_ADDED_TO_CART);
  // }
  togglePassword() {
    console.log('toggle');
    this.PassType = (<HTMLInputElement>document.getElementById('pass')).type;

    if (this.PassType === 'password') {
      console.log('toggle', this.PassType);

      this.PassType = 'text';
      (<HTMLInputElement>document.getElementById('pass')).type = this.PassType;
    } else {
      this.PassType = 'password';
      (<HTMLInputElement>document.getElementById('pass')).type = this.PassType;
      console.log('toggle', this.PassType);
    }
  }


  loadBanner() {
    let response = this.server.LoadBannersOnHomePage();
    response.subscribe(
      (data) => {
        console.log('banners', data);
        this.globals.banner_color = data.banner_color;
        this.globals.giftCard_color = data.gift_cards_color;
        this.globals.myRewards_color = data.my_rewards_color;
        this.globals.orderNow_color = data.order_now_color;
        this.globals.specialOffer_color = data.special_offer_color;
        this.globals.themeColor = data.theme_color;
        // this.globals.cash_discount = data.cash_discount;

        // this.globals.cash_discount_enabled = data.cash_discount_enabled;
        // this.globals.cash_discount_percentage = data.cash_discount_percentage;
        // this.globals.cash_discount_value = data.cash_discount_value;

        //newadded
        this.globals.BusinessDiscount = data.discount;
        this.globals.availed_discount_count = parseInt(
          data.customer_discount_availed_count
        );
        this.globals.business_discount_count = parseInt(
          data.business_discount_count
        );
        //new added
        // ll
        if (data.theme_color) {
          this.globals.appColor = data.theme_color;
        } else {
          this.globals.appColor = '#000000';
        }

        // this.globals.cash_discount = data.cash_discount;

        // this.globals.cash_discount_enabled = data.cash_discount_enabled;
        // this.globals.cash_discount_percentage = data.cash_discount_percentage;
        // this.globals.cash_discount_value = data.cash_discount_value;
      },
      async (error) => {
        console.log('no network', error);
        let alert = await this.alertCtrl.create({
          message:
            "Looks like you're not connected to Internet. turn on your mobile data or Wi-Fi.",
          buttons: ['OK'],
        });
        alert.present();
      }
    );
  }
}
